/**
 * @generated SignedSource<<1e4008cf1a810da5a69af68580d2d27c>>
 * @relayHash f13961bf02127962900ef43b1b0957b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0381d6bd7bbe5617a5660feab9ea1ef587bd4c9822f831ab5b078936b0bd4726

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { SupportWebsitePagesQuery } from './SupportWebsitePagesQuery.graphql';

const node: PreloadableConcreteRequest<SupportWebsitePagesQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "0381d6bd7bbe5617a5660feab9ea1ef587bd4c9822f831ab5b078936b0bd4726",
    "metadata": {
      "connection": [
        {
          "count": "NUMBER_OF_PAGES_INITIAL_FETCH",
          "cursor": null,
          "direction": "forward",
          "path": [
            "helpCenter",
            "helpCenterPages"
          ]
        }
      ]
    },
    "name": "SupportWebsitePagesQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
